import { render, staticRenderFns } from "./DlsCzjlList.vue?vue&type=template&id=19f5b8c8"
import script from "./DlsCzjlList.vue?vue&type=script&lang=js"
export * from "./DlsCzjlList.vue?vue&type=script&lang=js"
import style0 from "./DlsCzjlList.vue?vue&type=style&index=0&id=19f5b8c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports